import { getSurveyClosedReason } from "../api/surveyClosedReason";
import GenericDictionaryPage from "./GenericDictionaryPage";

export default function SurveyClosedReason() {
    return (
        <GenericDictionaryPage
            tableKey="surveyClosedReason"
            fetchData={getSurveyClosedReason}
            titleKey="genericDic:surveyClosedReason"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:surveyClosedReason").toLowerCase()
                })
            }
        />
    );
}
